import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { deleteDoc, doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "firebaseApp";
import React from "react";
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { COLLECTIONS } from "firebaseCollections";

export default function BookmarkMessageMenuItem({ message, callback }) {

  const toogleBookmarked = async () => {
    const newBookmarked = message.bookmarked ? false : true;
    await updateDoc(doc(db, COLLECTIONS.messages, message.id), {
      bookmarked: newBookmarked,
    });
    const bookmarkRef = doc(db, COLLECTIONS.bookmarks, message.id);
    if(newBookmarked) {
      await setDoc(bookmarkRef, {
        ...message, 
        bookmarked: true,
        bookmarkedAt: new Date().getTime()
      });
    } else {
      await deleteDoc(bookmarkRef);
    }
    callback();
  };

  return (
    <MenuItem onClick={toogleBookmarked}>
      <ListItemIcon>
        {message.bookmarked ? (
          <BookmarkIcon color="text" fontSize="small" />
        ) : (
          <BookmarkBorderIcon color="text" fontSize="small" />
        )}
      </ListItemIcon>
      <ListItemText>{message.bookmarked ? "Unmark" : "Bookmark"}</ListItemText>
    </MenuItem>
  );
}
